// DocumentStatus.js
import classes from "./DocumentStatus.module.css";
import CommonCard from "../../ui/CommonCard/CommonCard";
import BreadCrumb from "../../ui/BreadCrumb/BreadCrumb";
import { PiCopyLight } from "react-icons/pi";
import CreateIcon from "../../../icons/CreateIcon";
import UserPortraitIcon from "../../../icons/UserPortraitIcon";
import DocumentIcon from "../../../icons/DocumentIcon";
import ApprovedIcon from "../../../icons/ApprovedIcon";
import DisposedIcon from "../../../icons/DisposedIcon";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { env } from "../../../constants/env";

// const timelineData = [
//   {
//     status: "completed",
//     icon: <CreateIcon />,
//     action: "Created",
//     date: "12.05.24 - 12:00 PM",
//     user: "John Marston",
//   },
//   {
//     status: "completed",
//     icon: <UserPortraitIcon />,
//     action: "Submitted for approval",
//     date: "12.05.24 - 15:00 PM",
//     user: "Michael Hutchins",
//   },
//   {
//     status: "rejected",
//     icon: <DocumentIcon />,
//     action: "Rejected",
//     date: "12.05.24 - 18:00 PM",
//     user: "Michael Hutchins",
//     badge: "View",
//   },
//   {
//     status: "current",
//     icon: <UserPortraitIcon />,
//     action: "Submitted for approval",
//     date: "12.05.24 - 15:00 PM",
//     user: "Michael Hutchins",
//   },
//   {
//     status: "pending",
//     icon: <ApprovedIcon />,
//     action: "Approved",
//     statusNote: "Pending",
//   },
//   {
//     status: "pending",
//     icon: <DisposedIcon />,
//     action: "Disposed",
//     statusNote: "Pending",
//   },
// ];

const iconMap = {
  CreateIcon: <CreateIcon />,
  DocumentIcon: <DocumentIcon />,
  PendingIcon: <DisposedIcon />,
  DefaultIcon: <UserPortraitIcon />,
};

// const metaTags = [
//   { content: "#1219295591", icon: <PiCopyLight size={15} /> },
//   { content: "Status Rejected" },
//   { content: "Assigned Michael Hutchins" },
//   { content: "Urgency Not set" },
//   { content: "Approval Not set" },
//   { content: "Disposal Not set" },
//   { content: "Template Document template name" },
// ];

const DocumentStatus = () => {
  const navigate = useNavigate();
  const { submitId } = useParams();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [timeline, setTimeline] = useState([]);

  const lastStep = timeline[timeline.length - 1];

  const token = localStorage.getItem("formioToken");

  let metaTags = [];

  if (lastStep) {
    metaTags = [
      formData?.form?.tags?.[1] && {
        content: `#${formData.form.tags[1]}`,
        icon: <PiCopyLight size={15} />,
      },
      lastStep.status && {
        content: `Status ${capitalizeFirst(lastStep.status)}`,
      },
      lastStep.user && {
        content: `Assigned ${lastStep.user}`,
      },
    ].filter((tag) => tag !== null && tag !== undefined);
  }

  function capitalizeFirst(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  useEffect(() => {
    if (submitId) {
      axios
        .get(`${env.apiUrl}/api/submissions/${submitId}`)
        .then((response) => {
          setFormData(response.data);
          setLoading(false);
          console.log("Fetched document:", response.data);
        })
        .catch((error) => {
          console.error("Error fetching document:", error);
          setLoading(false);
        });
    }
    const markAsRead = async () => {
      try {
        await axios.patch(
          `${env.apiUrl}/api/submissions/${submitId}/read`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (err) {
        console.error("Failed to mark as read:", err);
      }
    };

    markAsRead();
  }, [submitId]);

  useEffect(() => {
    const fetchTimeline = async () => {
      try {
        const response = await fetch(
          `${env.apiUrl}/api/audit-trail/${submitId}`
        );
        const data = await response.json();

        const formatted = data.map((item) => ({
          ...item,
          icon: iconMap[item.icon] || <DisposedIcon />,
        }));

        setTimeline(formatted);
      } catch (error) {
        console.error("Error fetching timeline:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTimeline();
  }, []);

  if (loading) return <div>Loading...</div>;
  return (
    <>
      <BreadCrumb
        cancelText="back"
        createText="Open document"
        onCreate={() => navigate(`/activity/submitted-documents/${submitId}`)}
      />
      <div className={classes.wrapper}>
        <CommonCard>
          <h3 className={classes.documentName}>{formData?.form?.title}</h3>
          <div
            className={`mt-4 ${classes.metaRow} d-flex flex-wrap align-items-center gap-3`}
          >
            {metaTags.map((tag, idx) => (
              <div key={idx} className={classes.tagContainer} role="button">
                {tag.content} {tag.icon && tag.icon}
              </div>
            ))}
          </div>

          <hr className={classes.divider} />

          <h4 className={classes.sectionTitle}>Audit trail</h4>

          <div className={classes.horizontalTimeline}>
            {timeline.map((item, idx) => (
              <div
                key={idx}
                className={`${classes.timelineItem} ${classes[item.status]}`}
              >
                <div className={classes.timelineDotContainer}>
                  <div className={classes.timelineDot}></div>
                </div>
                <div className={classes.timelineCard}>
                  {item.icon}
                  <div className={classes.timelineContent}>
                    <div className={classes.timelineAction}>{item.action}</div>
                    {item.date && (
                      <div className={classes.timelineDate}>{item.date}</div>
                    )}
                    {item.user && (
                      <div className={classes.timelineUser}>
                        {item.user}
                        {item.badge && (
                          <span className={classes.viewBadge}>
                            {item.badge}
                          </span>
                        )}
                      </div>
                    )}
                    {item.statusNote && (
                      <div className={classes.timelineStatus}>
                        {item.statusNote}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CommonCard>
      </div>
    </>
  );
};

export default DocumentStatus;
